import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function SafetySection() {
  const { t } = useTranslation();

  const items = [
    { key: 'safety.1', icon: 'ri-shield-line' },
    { key: 'safety.2', icon: 'ri-lock-password-line' },
    { key: 'safety.3', icon: 'ri-download-2-line' },
    { key: 'safety.4', icon: 'ri-question-line' },
  ];

  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
            <i className="ri-shield-check-line" />
            {t('nav.safety')}
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950">{t('safety.title')}</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">{t('safety.subtitle')}</p>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">{t('safety.p1')}</p>
          <Link
            to="/article/usfans-spreadsheet-guide"
            className="mt-6 inline-flex items-center gap-2 rounded-md bg-accent-500 px-5 py-3 text-sm font-semibold text-background-50 hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('safety.cta')}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {items.map((item) => (
            <div key={item.key} className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className={`${item.icon} text-base`} />
              </span>
              <p className="text-sm font-medium text-foreground-800 leading-snug">{t(item.key)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}